<mds-dialog dialogTitle="Patient Status">
    <mds-dialog-content [formGroup]="patientStatusChangeFormGroup">
        <div class="o-grid">
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Current Status</h5>
                        <span>{{ this?.textStatus }}</span>
                    </div>
                </div>
            </div>
            @if (displayStatus?.length > 0) {
                <div class="o-grid__row">
                    <div class="o-grid__field">
                        <mds-dropdown
                            [closeOnPageScroll]="false"
                            formCtrlName="statusDropdownControl"
                            appearance="outline"
                            label="Change Status to"
                            placeholder="Please Select Status"
                            [options]="displayStatus"
                            id="patientStatusDropdown"
                            [formGrp]="patientStatusChangeFormGroup"
                            [required]="true"
                        ></mds-dropdown>
                    </div>
                </div>
            } @else {
                <div class="spinnerOverlay">
                    <medpace-loading-card></medpace-loading-card>
                </div>
            }
        </div>
    </mds-dialog-content>
    <mds-dialog-actions [align]="'end'">
        <div class="flex flex-row gap-medpace">
            <mds-button [id]="'cancel-btn'" label="Cancel" (clickEvent)="closeDialog()" variant="outline"> </mds-button>
            <mds-button
                [id]="'confirm-btn'"
                id="changePatientStatusConfirmBtn"
                label="Confirm"
                (clickEvent)="saveDialog()"
                [color]="'primary'"
                [variant]="'filled'"
            >
            </mds-button>
        </div>
    </mds-dialog-actions>
</mds-dialog>
